// import About from "../../components/About/About";
import Container from "../../components/container/Container";
import CreateDiscussionModal from "../../components/CreateDiscussionModal/CreateDiscussionModal";
import HomepageIntro from "../../components/HomepageIntro/HomepageIntro";
import HomePageNoRoom from "../../components/HomePageNoRoom/HomePageNoRoom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../database/firebase";
// import useCollection from "../../hooks/DatabseCollection/userCollection";
import RoomsCard from "../../components/RoomsCard/RoomsCard";
import useUserId from "../../hooks/DatabseCollection/useUserId";

const Homepage = () => {
  const [user] = useAuthState(auth);
  const [userRoomsData] = useUserId(user.uid);

  return (
    <section className="relative pb-5">
      <Container>
        <div className="mt-10 lg:grid lg:grid-cols-2 lg:gap-10">
          {userRoomsData?.length > 0 ? (
            <RoomsCard roomsData={userRoomsData} />
          ) : (
            <HomePageNoRoom />
          )}
          <div className="relative hidden lg:inline-grid">
            <HomepageIntro />
          </div>
        </div>
        <CreateDiscussionModal />
      </Container>
    </section>
  );
};

export default Homepage;
